import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
import { LoginService } from '../../../common/services/Login.service';
import { SessionService } from '../../../common/services/Session.service';

@Component({
  selector: 'app-help-pendingcontent-system',
  templateUrl: './help-pendingcontent-system.component.html'
})
export class HelpPendingcontentSystemComponent implements OnInit {
  role: any;
    userId: any;

  constructor(public commonDataService: CommonDataService,
    private graphQlService: GraphqlService, private route: Router, private sanitizer: DomSanitizer, private session: SessionService, private loginService : LoginService) {
  }
  pcs_heading;
  pcs_para1heading;
  pcs_para1body;
  pcs_para2heading;
  pcs_para2body;
  pcs_para3heading;
  pcs_para3body;
  pcs_decline;
  pcs_agree;
  pc_agreementText;
  content1TC;
  content2TC;
  content3TC;
  userSession : any[] ;
  Isnotloginpage = true;
  IsRightPanel:boolean;
  ngOnInit(): void {

    this.IsRightPanel = this.commonDataService.showRightPanel.getValue();
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        this.userId = data.user.firstname + " " + data.user.lastname;
        this.role = data.user.roles;
        this.session.assignUserInfo(data.user);
      })
    }
    else {
      this.userId = this.session.userInfo.user.firstname + " " + this.session.userInfo.user.lastname;
      this.role = this.session.userInfo.user.roles;
    }
    if (this.route.url == '/Login') {
      this.Isnotloginpage = false;
    }
    window.scrollTo(0, 0);
    
    this.commonDataService.showLoader.next(true);
    this.gethelppendingcontentsystemlabels();
  }
  pc_BodyDesc;
  pc_BodyPreDesc3;
  pc_BodyPreDesc; pc_BodyPreDesc2;
  gethelppendingcontentsystemlabels() {


    this.graphQlService.gethelppcsLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.pc_BodyDesc = labels.filter(x => x.key == "pc_BodyDesc").map(y => y.value);
        this.pc_BodyPreDesc = labels.filter(x => x.key == "pc_BodyPreDesc").map(y => y.value);
        this.pcs_heading = labels.filter(x => x.key == "pcs_heading").map(y => y.value);
        //this.pcs_para1heading = labels.filter(x => x.key == "pcs_para1heading").map(y => y.value);
        //this.pcs_para1body = labels.filter(x => x.key == "pcs_para1body").map(y => y.value);
        //this.pcs_para2heading = labels.filter(x => x.key == "pcs_para2heading").map(y => y.value);
        //this.pcs_para2body = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "pcs_para2body").map(y => y.value));
        //this.pcs_para3heading = labels.filter(x => x.key == "pcs_para3heading").map(y => y.value);
        //this.pcs_para3body = labels.filter(x => x.key == "pcs_para3body").map(y => y.value);
        //this.pcs_decline = labels.filter(x => x.key == "pcs_decline").map(y => y.value);
        //this.pcs_agree = labels.filter(x => x.key == "pcs_agree").map(y => y.value);
        //this.pc_agreementText = labels.filter(x => x.key == "pc_agreementText").map(y => y.value);
        this.pc_BodyPreDesc2 = labels.filter(x => x.key == "pc_BodyPreDesc2").map(y => y.value); 
        this.pc_BodyPreDesc3 = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "pc_BodyPreDesc3").map(y => y.value)[0]);
        this.content1TC = this.pc_BodyPreDesc2[0]?.split("[Terms_And_Condition]")[0]
        this.content2TC = "Terms And Condition"
        this.content3TC = this.sanitizer.bypassSecurityTrustHtml(this.pc_BodyPreDesc2[0]?.split("[Terms_And_Condition]")[1]);
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });


  }
  homepageredirect() {
    this.route.navigateByUrl("/Home");
  }
  acceptTC() {
    /*this.graphQlService.SetPendingContentAgreementSession(true).subscribe(data => {*/
      this.route.navigate(['pendingcontentsystem']);
    //}, err => {
    //  console.log(err);
    //  this.commonDataService.showLoader.next(false);
    //});
  }
  showTC() {
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightOverlayOption.next("Terms And Conditions");
    this.commonDataService.rightPanelWidth.next("rightOverlay_large");
    this.commonDataService.tcsource.next("pendingcontentsystem");
    this.commonDataService.closeModalOption.next(true);
  }
  openLinkbyId(event) {
    let id = event.target.id;
    if (id != "") {
      if (this.route.url == '/Login') {
        this.commonDataService.NavigatingFromComponent.next("helppcs");
        this.commonDataService.childComponent.next(true);
        this.commonDataService.rightPanelWidth.next("rightOverlay_large");
        this.commonDataService.showRightPanel.next(true);
        this.commonDataService.rightOverlayOption.next(id);
      } else {
        this.route.navigate([event.target.id]);
      }
    }
  }
}
